// extracted by mini-css-extract-plugin
export default {"updateButton":"style_updateButton__gqgaR","modalContent":"style_modalContent__ZrOwt"};